import { Box, Button, Typography } from '@mui/material';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import IconButtonTitle from 'modules/common/component/IconButtonTitle';
import MediCard from 'modules/common/component/MediCard';
import TableCustom, { Columns } from 'modules/common/component/TableCustom';
import { some } from 'modules/common/constants';
import { ROUTES } from 'modules/layout/router';
import { NumericFormatText } from 'modules/common/utils';
interface Props {
  data?: some;
  onSubmitForm: (item: some) => void;
  setFormDataGroup: (item: some) => void;
  onDelete: (item: some) => void;
  onDeleteGroup: (item: some) => void;
  loading?: boolean;
  isInsurance?: boolean;
  onReference?: (item: some) => void;
}

const IndicationCSVTable: React.FunctionComponent<Props> = (props) => {
  const { data, onSubmitForm, setFormDataGroup, onDelete, onDeleteGroup, onReference, loading } = props;
  const location = useLocation();

  const columns = React.useMemo(() => {
    return [
      {
        title: 'serviceCode',
        dataIndex: 'code',
      },
      {
        title: 'serviceName',
        dataIndex: 'name',
        render: (record) => <Typography color={record?.name.length > 255 ? 'red' : ''}>{record?.name}</Typography>,
      },
      {
        title: 'departmentCode',
        dataIndex: 'specializedDepartmentId',
      },
      {
        title: 'indication.room',
        dataIndex: 'physicsRoomId',
      },

      {
        title: 'indication.device',
        dataIndex: 'medicalEquipmentId',
      },
      {
        title: 'price',
        align: 'right',
        dataIndex: 'price',
        render: (record) => record.price && NumericFormatText(record.price),
      },
      {
        title: 'action',
        align: 'right',
        width: 160,
        render: (record) => {
          return (
            <>
              <IconButtonTitle
                title="update"
                size="small"
                onClick={() => {
                  onSubmitForm({
                    ...record,
                    systemCategoryId: data?.id,
                    specializedDepartment: { id: record.specializedDepartmentId },
                    medicalEquipment: { id: record.medicalEquipmentId },
                    physicsRoom: { id: record.physicsRoomId },
                  });
                }}
              >
                <EditIcon color={record.validation === false ? 'error' : undefined} />
              </IconButtonTitle>
              <IconButtonTitle
                title="delete"
                size="small"
                onClick={() => {
                  onDelete({ ...record, listId: data?.id, listData: data?.services, allItems: data?.allItems });
                }}
                style={{ margin: '0px 8px' }}
              >
                <DeleteIcon />
              </IconButtonTitle>
              {onReference ? (
                <IconButtonTitle
                  title="create"
                  size="small"
                  onClick={() => {
                    onReference(record);
                  }}
                >
                  <AssignmentReturnIcon
                    color={record.validationItems === false ? 'error' : undefined}
                    style={{ transform: 'rotateY(180deg)' }}
                  />
                </IconButtonTitle>
              ) : (
                <Link
                  to={{
                    pathname: ROUTES.referenceIndication.gen(data?.id, record?.id),
                    search: location.search,
                  }}
                >
                  <IconButtonTitle size="small">
                    <AssignmentReturnIcon style={{ transform: 'rotateY(180deg)' }} />
                  </IconButtonTitle>
                </Link>
              )}
            </>
          );
        },
      },
    ] as Columns[];
  }, [onReference, data?.id, data?.services, data?.allItems, location.search, onSubmitForm, onDelete]);

  if (!data) {
    return null;
  }

  return (
    <MediCard
      style={{ margin: '8px 0px', color: 'white' }}
      title={
        <Box display="flex" alignItems="center">
          <Box flex={1}>
            <Typography variant="subtitle1" color="inherit">
              {data.name}
            </Typography>
          </Box>
          <Box display="flex">
            <IconButtonTitle
              title="create"
              size="small"
              color="inherit"
              onClick={() =>
                onSubmitForm({
                  systemCategoryId: data?.id,
                })
              }
            >
              <NoteAddIcon />
            </IconButtonTitle>
            <IconButtonTitle
              title="update"
              size="small"
              color="inherit"
              onClick={() => setFormDataGroup(data)}
              style={{ marginRight: 8, marginLeft: 8 }}
            >
              <EditIcon />
            </IconButtonTitle>
            <IconButtonTitle
              title="delete"
              size="small"
              color="inherit"
              disabled={!!data.items?.length && !onReference}
              onClick={() => {
                onDeleteGroup(data);
              }}
            >
              <DeleteIcon />
            </IconButtonTitle>
          </Box>
        </Box>
      }
    >
      <Box padding={1}>
        <TableCustom
          dataSource={data?.items}
          loading={loading}
          columns={columns}
          caption={
            <Button
              size="large"
              fullWidth
              variant="text"
              startIcon={<NoteAddIcon />}
              color="primary"
              onClick={() => onSubmitForm({ systemCategoryId: data?.id })}
            >
              <Typography variant="subtitle2">
                <FormattedMessage id="indication.addNewInList" />
              </Typography>
            </Button>
          }
        />
      </Box>
    </MediCard>
  );
};

export default IndicationCSVTable;
